import { colors, LayoutBand } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { MERGE_LAYOUT_MARGIN } from './helpers'

type DecoratorProps = {
  children: ReactNode
}

export default function OneMergePageDecorator({ children }: DecoratorProps): JSX.Element {
  return (
    <LayoutBand marginX={MERGE_LAYOUT_MARGIN}>
      <LayoutBand color={colors.gray00} style={{ minHeight: '100vh' }}>
        {children}
      </LayoutBand>
    </LayoutBand>
  )
}
